"use strict";

var _interopRequireWildcard = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
var _vue = _interopRequireDefault(require("vue"));
require("normalize.css");
var _elementUi = _interopRequireWildcard(require("element-ui"));
var _vueSvgicon = _interopRequireDefault(require("vue-svgicon"));
require("@/styles/element-variables.scss");
require("@/styles/index.scss");
var _App = _interopRequireDefault(require("@/App.vue"));
var _store = _interopRequireDefault(require("@/store"));
var _app = require("@/store/modules/app");
var _router = _interopRequireDefault(require("@/router"));
var _lang = _interopRequireDefault(require("@/lang"));
require("@/icons/components");
require("@/permission");
require("@/utils/error-log");
require("@/pwa/register-service-worker");
var directives = _interopRequireWildcard(require("@/directives"));
var filters = _interopRequireWildcard(require("@/filters"));
var _vueMoment = _interopRequireDefault(require("vue-moment"));
var _vuePluginLoadScript = _interopRequireDefault(require("vue-plugin-load-script"));
var _vueQrcode = _interopRequireDefault(require("@chenfengyuan/vue-qrcode"));
var _vueCtkDateTimePicker = _interopRequireDefault(require("vue-ctk-date-time-picker"));
require("vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css");
require("element-ui/lib/theme-chalk/display.css");
var _idleVue = _interopRequireDefault(require("idle-vue"));
var _admin = require("@/store/modules/admin");
var _roles = require("./constants/roles.constants");
var _axios = _interopRequireDefault(require("axios"));
var _readAccessMixin = _interopRequireDefault(require("@/mixins/read-access-mixin"));
var _vueApexcharts = _interopRequireDefault(require("vue-apexcharts"));
_vue.default.component('VueCtkDateTimePicker', _vueCtkDateTimePicker.default);
_vue.default.use(_elementUi.default, {
  size: _app.AppModule.size,
  i18n: (key, value) => _lang.default.t(key, value)
});
_vue.default.use(_vueMoment.default);
_vue.default.use(_vuePluginLoadScript.default);
_vue.default.component(_vueQrcode.default.name, _vueQrcode.default);
_vue.default.use(_vueSvgicon.default, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
});
_vue.default.use(_vueApexcharts.default);
_vue.default.component('apexchart', _vueApexcharts.default);
// Attach each constant directly to Vue prototype
_vue.default.prototype.SUPER_ADMIN = _roles.SUPER_ADMIN;
_vue.default.prototype.ADMIN = _roles.ADMIN;
_vue.default.prototype.UNIT_MANAGER = _roles.UNIT_MANAGER;
_vue.default.prototype.INVOICE_MANAGER = _roles.INVOICE_MANAGER;
_vue.default.prototype.READ_ONLY = _roles.READ_ONLY;
_vue.default.prototype.ACCOUNT_MANAGER = _roles.ACCOUNT_MANAGER;
_vue.default.prototype.ORDER_MANAGER = _roles.ORDER_MANAGER;
_vue.default.prototype.REGIONAL_MANAGER = _roles.REGIONAL_MANAGER;
_vue.default.prototype.PAYMENT_MANAGER = _roles.PAYMENT_MANAGER;
_vue.default.prototype.ZONAL_MANAGER = _roles.ZONAL_MANAGER;
_vue.default.prototype.BRANCH_MANAGER = _roles.BRANCH_MANAGER;
_vue.default.mixin(_readAccessMixin.default);
const eventsHub = new _vue.default();
_vue.default.use(_idleVue.default, {
  eventEmitter: eventsHub,
  // idleTime: 9 * 60 * 1000, // 9 minutes for local
  idleTime: 20 * 60 * 1000 // 9 minutes for local
});
let idleConfirmInstance = null;
let idleCountdownTimeout = null;
// Listen for idle event on every 9th/20th minute of inactivity
eventsHub.$on('idleVue_onIdle', () => {
  // if not logged in, return
  if (!_admin.AdminModule.id) return;
  // on login page already
  if (_router.default.currentRoute.path === '/login' || _router.default.currentRoute.path === '/agent-login') {
    return;
  }
  // check if admin is of forcedLogout
  if (_admin.AdminModule.forcedLogout === true) {
    // Broadcast the idle event across tabs
    localStorage.setItem('idleWarning', JSON.stringify({
      time: Date.now()
    }));
    // handle warning
    handleIdleWarning();
  }
});
// Function to handle idle warning popup
function handleIdleWarning() {
  // Close previous popup if open
  if (idleCountdownTimeout) {
    _elementUi.MessageBox.close();
  }
  // Show idle popup
  idleConfirmInstance = _elementUi.MessageBox.confirm('You will be logged out soon due to inactivity.', 'No activity found!', {
    confirmButtonText: 'Stay Logged In',
    showClose: false,
    closeOnPressEscape: false,
    closeOnClickModal: false,
    showCancelButton: false,
    type: 'warning',
    callback: () => {
      // Clear countdown
      if (idleCountdownTimeout) {
        clearTimeout(idleCountdownTimeout);
        idleCountdownTimeout = null;
      }
      // Ping the server to keep the session alive
      _axios.default.get(`${process.env.VUE_APP_BASE_API}admins/ping`, {
        headers: {
          Authorization: `Bearer ${_admin.AdminModule.token}`
        }
      }).then(response => {
        console.log('Response:', response.data);
      }).catch(error => {
        console.error('Error:', error);
      });
      // Broadcast activity to other tabs
      localStorage.setItem('userActive', JSON.stringify({
        time: Date.now()
      }));
    }
  });
  // Set timeout to log out after 1 minute
  idleCountdownTimeout = setTimeout(() => {
    logOutUser();
  }, 1 * 60 * 1000); // 1 minute
}
// Function to log out user
function logOutUser() {
  if (_admin.AdminModule.userType === 'Admin' && _admin.AdminModule.forcedLogout === true) {
    _admin.AdminModule.LogOut();
    _router.default.push('/login');
  } else if (_admin.AdminModule.userType === 'agent') {
    _admin.AdminModule.AgentLogOut();
    _router.default.push('/agent-login');
  }
  // Close popup and clear timeout
  if (idleCountdownTimeout) {
    clearTimeout(idleCountdownTimeout);
    idleCountdownTimeout = null;
  }
  _elementUi.MessageBox.close();
  // Broadcast logout event to other tabs
  localStorage.setItem('userLoggedOut', JSON.stringify({
    time: Date.now()
  }));
}
// Listen for localStorage changes (cross-tab communication)
window.addEventListener('storage', event => {
  if (event.key === 'idleWarning' && event.newValue) {
    const data = JSON.parse(event.newValue);
    const timeDifference = Date.now() - data.time;
    // Handle idle warning in other tabs if it's recent
    if (timeDifference < 5000 && _admin.AdminModule.forcedLogout === true) {
      handleIdleWarning();
    }
  }
  if (event.key === 'userLoggedOut' && event.newValue) {
    const data = JSON.parse(event.newValue);
    const timeDifference = Date.now() - data.time;
    // Log out from other tabs if it's recent
    if (timeDifference < 5000 && _admin.AdminModule.forcedLogout === true) {
      logOutUser();
    }
  }
  if (event.key === 'userActive' && event.newValue) {
    const data = JSON.parse(event.newValue);
    const timeDifference = Date.now() - data.time;
    // Close idle popup and clear timer if activity is detected in another tab
    if (timeDifference < 5000 && idleCountdownTimeout) {
      clearTimeout(idleCountdownTimeout);
      idleCountdownTimeout = null;
      _elementUi.MessageBox.close();
    }
  }
});
// Cancel idle warning and logout if the user becomes active
eventsHub.$on('idleVue_onActive', () => {
  if (idleCountdownTimeout) {
    clearTimeout(idleCountdownTimeout);
    idleCountdownTimeout = null;
    _elementUi.MessageBox.close();
  }
  // Broadcast user activity to other tabs
  localStorage.setItem('userActive', JSON.stringify({
    time: Date.now()
  }));
});
// Register global directives
Object.keys(directives).forEach(key => {
  _vue.default.directive(key, directives[key]);
});
// Register global filter functions
Object.keys(filters).forEach(key => {
  _vue.default.filter(key, filters[key]);
});
_vue.default.config.productionTip = false;
new _vue.default({
  router: _router.default,
  store: _store.default,
  i18n: _lang.default,
  render: h => h(_App.default)
}).$mount('#app');